// Харилцагч (customer) -ийн бүртгэл, нэвтрэлт, өөрийн ачаа шалгах action-ууд.
// Энэ нь админ auth-аас тусдаа: customer token-ийг localStorage-д 'customer_token'
// нэрээр, профайлыг 'customer' нэрээр хадгална.

const API_HOST = process.env.NEXT_PUBLIC_HOSTNAME;

const getCustomerToken = () => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem("customer_token");
};

export const getCustomerProfile = () => {
  if (typeof window === "undefined") return null;
  try {
    return JSON.parse(localStorage.getItem("customer"));
  } catch (e) {
    return null;
  }
};

export const isCustomerLoggedIn = () => !!getCustomerToken();

// POST /customer/register  { name, phone, email }
export const registerCustomer = async (data) => {
  try {
    const res = await fetch(`${API_HOST}customer/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return await res.json();
  } catch (err) {
    return { error: err };
  }
};

// POST /customer/login  { identifier, password }  -> token хадгална
// identifier нь утас ЭСВЭЛ имэйл
export const forgotPassword = async (email) => {
  try {
    const res = await fetch(`${API_HOST}customer/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ email }),
    });
    return await res.json();
  } catch (err) {
    return { error: err };
  }
};

export const resetPassword = async (token, password) => {
  try {
    const res = await fetch(`${API_HOST}customer/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ token, password }),
    });
    return await res.json();
  } catch (err) {
    return { error: err };
  }
};

export const loginCustomer = async (data) => {
  try {
    const res = await fetch(`${API_HOST}customer/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await res.json();

    if (result.code === 200 && result.data?.token) {
      localStorage.setItem("customer_token", result.data.token);
      localStorage.setItem(
        "customer",
        JSON.stringify({
          id: result.data.id,
          name: result.data.name,
          phone: result.data.phone,
          email: result.data.email,
        })
      );
    }
    return result;
  } catch (err) {
    return { error: err };
  }
};

// GET /customer/cargo?search=<код>  (customer token шаардлагатай)
export const getMyCargo = async (search) => {
  try {
    const token = getCustomerToken();
    const res = await fetch(
      `${API_HOST}customer/cargo${search ? `?search=${encodeURIComponent(search)}` : ""}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    return await res.json();
  } catch (err) {
    return { error: err };
  }
};

export const logoutCustomer = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem("customer_token");
  localStorage.removeItem("customer");
};

// localStorage дахь профайлын нэг талбарыг шинэчлэх (жишээ: имэйл солиход)
const patchStoredProfile = (patch) => {
  if (typeof window === "undefined") return;
  try {
    const cur = JSON.parse(localStorage.getItem("customer")) || {};
    localStorage.setItem("customer", JSON.stringify({ ...cur, ...patch }));
  } catch (e) {
    /* ignore */
  }
};

// ============================================================
// НЭВТЭРСЭН ХАРИЛЦАГЧ — профайл, нууц үг, имэйл солих
// ============================================================
const customerAuthHeaders = (json = true) => {
  const token = getCustomerToken();
  const h = { Accept: "application/json", Authorization: token ? `Bearer ${token}` : "" };
  if (json) h["Content-Type"] = "application/json";
  return h;
};

// GET /customer/me — одоогийн профайл
export const getMe = async () => {
  try {
    const res = await fetch(`${API_HOST}customer/me`, {
      method: "GET",
      headers: customerAuthHeaders(false),
    });
    return await res.json();
  } catch (err) {
    return { error: err };
  }
};

// POST /customer/change-password  { oldPassword, newPassword }
export const changeCustomerPassword = async (oldPassword, newPassword) => {
  try {
    const res = await fetch(`${API_HOST}customer/change-password`, {
      method: "POST",
      headers: customerAuthHeaders(),
      body: JSON.stringify({ oldPassword, newPassword }),
    });
    return await res.json();
  } catch (err) {
    return { error: err };
  }
};

// POST /customer/change-email/request  { newEmail, password }
export const requestEmailChange = async (newEmail, password) => {
  try {
    const res = await fetch(`${API_HOST}customer/change-email/request`, {
      method: "POST",
      headers: customerAuthHeaders(),
      body: JSON.stringify({ newEmail, password }),
    });
    return await res.json();
  } catch (err) {
    return { error: err };
  }
};

// POST /customer/change-email/verify  { code }
export const verifyEmailChange = async (code) => {
  try {
    const res = await fetch(`${API_HOST}customer/change-email/verify`, {
      method: "POST",
      headers: customerAuthHeaders(),
      body: JSON.stringify({ code }),
    });
    const result = await res.json();
    // Амжилттай бол localStorage дахь имэйлийг шинэчилнэ
    if (result?.code === 200 && result.data?.email) {
      patchStoredProfile({ email: result.data.email });
    }
    return result;
  } catch (err) {
    return { error: err };
  }
};

// ============================================================
// АДМИН: вэбсайтнаас бүртгүүлсэн харилцагчдыг хянах
// (админ токеноор — fetchRequest нь localStorage 'user'-ийн токенийг хавсаргана)
// ============================================================
import { get, post, put, destroy } from "utils/fetchRequest";

export const getCustomersAdmin = async (search, page, limit) => {
  try {
    const qs = `1=1${search ? `&search=${encodeURIComponent(search)}` : ""}${
      page ? `&page=${page}` : ""
    }${limit ? `&limit=${limit}` : ""}`;
    return await get(`customer/admin/list?${qs}`);
  } catch (err) {
    return { error: err };
  }
};

// PUT /customer/admin/:id  { name, phone, email } — админ харилцагчийн мэдээлэл засах
export const updateCustomerAdmin = async (id, data) => {
  try {
    return await put(`customer/admin/${id}`, data);
  } catch (err) {
    return { error: err };
  }
};

export const deleteCustomerAdmin = async (id) => {
  try {
    return await destroy(`customer/admin/${id}`);
  } catch (err) {
    return { error: err };
  }
};

export const bulkDeleteCustomersAdmin = async (ids) => {
  try {
    return await post(`customer/admin/bulk-delete`, { ids });
  } catch (err) {
    return { error: err };
  }
};

export const getPendingTrackingsAdmin = async (search, filter, page, limit) => {
  try {
    const qs = `1=1${search ? `&search=${encodeURIComponent(search)}` : ""}${
      filter ? `&filter=${filter}` : ""
    }${page ? `&page=${page}` : ""}${limit ? `&limit=${limit}` : ""}`;
    return await get(`customer/admin/tracking-codes?${qs}`);
  } catch (err) {
    return { error: err };
  }
};

export const lookupTrackingOwner = async (code) => {
  try {
    return await get(`customer/admin/lookup-tracking/${encodeURIComponent(code)}`);
  } catch (err) {
    return { error: err };
  }
};

export const adminResetCustomerPassword = async (id, password) => {
  try {
    return await post(`customer/admin/${id}/reset-password`, password ? { password } : {});
  } catch (err) {
    return { error: err };
  }
};
